var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logs"},_vm._l((_vm.logs),function(log){return _c('log-virtual',{key:log.sequence,attrs:{"log":log}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }